import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { foreignPresenceKey, parseForeignPresenceKey, type LinkPresence } from "@/lib/foreign-agents";
import { qk } from "@/lib/query/keys";
import type { AgentWithContext } from "@/lib/types";

const selectKey = (data: { agents: AgentWithContext[] }) => foreignPresenceKey(data.agents);

/**
 * Which users are foreign agents, and whether their machines are connected — for the
 * avatars drawn from a users row (cards, comments, pickers), which know nothing of
 * links. Read from the shared agents query, so it costs no request of its own, and
 * selected as a string so an avatar re-renders only when a foreign agent's presence
 * changes. Look an id up: `useForeignPresence().get(user.id)`.
 */
export function useForeignPresence(): Map<string, LinkPresence> {
  const key = useQuery({ queryKey: qk.agents(), queryFn: api.listAgents, select: selectKey }).data ?? "";
  return useMemo(() => parseForeignPresenceKey(key), [key]);
}
